import { get } from "../Common/remote/base_api";
export const Getprofilefranchise = (data) => {
  return get(`franchise/get-profile/`, data);
};
